import { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FiRefreshCw } from "react-icons/fi";
import { nseIndicesOptions } from "../Helper/Helperdata";
// import { useAuth } from "../../context/AuthContext";
import { useMarketSnapshot } from "../../context/MarketSnapshotContext";
import { useExport } from "../../hooks/useExport";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
// import { useExport } from "../../context/ExportContext";
import "./SmartMoneyScreener.css";
import { InfoTooltip } from "../Helper/InfoToolTip";
import { TOOLTIPS } from "../../helper/tooltilData";
import useLivePrices from "../../hooks/useLivePrices";
import { useIndexSymbols } from "../../context/IndexSymbolContext";

const INDICES = [
  "NIFTY 50",
  "NIFTY BANK",
  "NIFTY IT",
  "NIFTY NEXT 50",
  "NIFTY MIDCAP 100",
];

// const CrossoverMomentum = () => {
//   const navigate = useNavigate();
//   //   const { user } = useAuth();
//   const { downloadIntradayCSV, downloadIntradayExcel, sendReport } =
//     useExport();
//   const {
//     dashboardTrendData,
//     dashboardTrendLoading,
//     dashboardTrendError,
//     loadDashboardIndexTrend,
//     resetDashboardTrendData,
//   } = useMarketSnapshot();

//   const [selectedIndex, setSelectedIndex] = useState(
//     () => localStorage.getItem("selectedIndex") || "NIFTY 50",
//   );
//   const [sortKey, setSortKey] = useState("closingStrength");
//   const [sortDir, setSortDir] = useState("desc");
//   const [filter, setFilter] = useState("All");
//   const [sending, setSending] = useState(false);
//   const [openDropdown, setOpenDropdown] = useState(false);

//   // ── Fetch data ──
//   useEffect(() => {
//     if (!selectedIndex) return;
//     localStorage.setItem("selectedIndex", selectedIndex);

//     loadDashboardIndexTrend({ indexName: selectedIndex });

//     const interval = setInterval(
//       () => {
//         if (!document.hidden)
//           loadDashboardIndexTrend({ indexName: selectedIndex });
//       },
//       5 * 60 * 1000,
//     );

//     return () => clearInterval(interval);
//   }, [selectedIndex]);

//   // ── Close dropdown on outside click ──
//   useEffect(() => {
//     if (!openDropdown) return;
//     const close = () => setOpenDropdown(false);
//     window.addEventListener("click", close);
//     return () => window.removeEventListener("click", close);
//   }, [openDropdown]);

//   // ── Derived data ──
//   const trendRows = useMemo(
//     () => Object.values(dashboardTrendData || {}),
//     [dashboardTrendData],
//   );

//   const lastDate = useMemo(() => {
//     const d = trendRows?.[0]?.dates?.at(-1);
//     if (!d) return "";
//     return new Date(d).toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   }, [trendRows]);

//   // ── Sort + filter (same pattern as SmartMoneyScreener) ──
//     const sorted = useMemo(() => {
//       const filtered =
//         filter === "All"
//           ? trendRows
//           : trendRows.filter((s) => {
//               const sig = s?.prediction?.toUpperCase?.();
//               if (filter === "Bullish") return sig === "BUY" || sig === "BULLISH";
//               if (filter === "Bearish")
//                 return sig === "SELL" || sig === "BEARISH";
//               return sig !== "BUY" && sig !== "BULLISH" && sig !== "SELL" && sig !== "BEARISH";
//             });

//       return [...filtered].sort((a, b) => {
//         const mA = getMetrics(a);
//         const mB = getMetrics(b);

//         if (!mA && !mB) return 0;
//         if (!mA) return 1;
//         if (!mB) return -1;

//         let aVal, bVal;

//         if (sortKey === "symbol") {
//           aVal = a?.symbol || "";
//           bVal = b?.symbol || "";
//           return sortDir === "asc"
//             ? aVal.localeCompare(bVal)
//             : bVal.localeCompare(aVal);
//         }

//         if (sortKey === "prediction") {
//           const rank = { BULLISH: 1, BUY: 1, NEUTRAL: 2, BEARISH: 3, SELL: 3 };
//           aVal = rank[a?.prediction?.toUpperCase?.()] || 99;
//           bVal = rank[b?.prediction?.toUpperCase?.()] || 99;
//         } else if (sortKey === "r1") {
//           aVal = a?.resDaily?.classic?.R1 ?? -Infinity;
//           bVal = b?.resDaily?.classic?.R1 ?? -Infinity;
//         } else if (sortKey === "s1") {
//           aVal = a?.resDaily?.classic?.S1 ?? -Infinity;
//           bVal = b?.resDaily?.classic?.S1 ?? -Infinity;
//         } else {
//           aVal = mA?.[sortKey] ?? -Infinity;
//           bVal = mB?.[sortKey] ?? -Infinity;
//         }

//         return sortDir === "asc" ? aVal - bVal : bVal - aVal;
//       });
//     }, [trendRows, filter, sortKey, sortDir]);

//   // ── Sort handler (same as SmartMoneyScreener) ──
//   const handleSort = useCallback(
//     (key) => {
//       if (sortKey === key) setSortDir(sortDir === "desc" ? "asc" : "desc");
//       else {
//         setSortKey(key);
//         setSortDir("desc");
//       }
//     },
//     [sortKey, sortDir],
//   );

//   // ── Handlers ──
//   const handleIndexChange = useCallback((e) => {
//     const value = e.target.value;
//     if (!value) return;
//     resetDashboardTrendData();
//     setSelectedIndex(value);
//   }, []);

//   const handleRefresh = useCallback(() => {
//     loadDashboardIndexTrend({ indexName: selectedIndex });
//   }, [selectedIndex]);

//   //   const handleSendReport = useCallback(async () => {
//   //     try {
//   //       setSending(true);
//   //       await sendReport({ type: "eod", email: user?.userID });
//   //       window.alert("📧 Report sent!");
//   //     } catch {
//   //       window.alert("❌ Failed to send report");
//   //     } finally {
//   //       setSending(false);
//   //     }
//   //   }, [user?.userID]);

//   // ── Reusable SortTh (same as SmartMoneyScreener) ──
//   const SortTh = ({ label, field, align, tooltip }) => (
//     <th
//       onClick={() => handleSort(field)}
//       className={align === "left" ? "sm__th-left" : ""}
//     >
//       {label}
//       {/* {tooltip && <InfoTooltip text={tooltip} />} */}
//       {sortKey === field && (
//         <span className="sm__sort-arrow">
//           {sortDir === "asc" ? " ↑" : " ↓"}
//         </span>
//       )}
//     </th>
//   );
//   console.log("Dashboard data", dashboardTrendData);
//   return (
//     <div className="sm">
//       {/* ── Header ── */}
//       <div className="sm__header">
//         <div className="sm__header-left">
//           <div className="sm__title-row">
//             <button className="sm__back" onClick={() => navigate(-1)}>
//               ←
//             </button>
//             <h1 className="sm__title">EOD Trend Analysis</h1>
//           </div>
//           <p className="sm__sub">
//             Closing strength, rebound strength &amp; distance to high across
//             index stocks
//           </p>
//         </div>

//         <div className="sm__header-right">
//           <select
//             className="sm__index-select"
//             value={selectedIndex}
//             onChange={handleIndexChange}
//           >
//             {INDICES.map((idx) => (
//               <option key={idx} value={idx}>
//                 {idx}
//               </option>
//             ))}
//           </select>

//           <button className="sm__refresh-btn" onClick={handleRefresh}>
//             <FiRefreshCw size={14} />
//           </button>
//         </div>
//       </div>

//       {/* ── Meta bar ── */}
//       <div className="sm__result-bar">
//         <span>
//           {/* {lastDate && `As on ${lastDate}`} — <b>{sorted.length}</b> stocks */}
//         </span>
//       </div>

//       {/* ── Loading / Error ── */}
//       {/* {dashboardTrendLoading && !sorted.length && (
//         <div className="sm__loading">Fetching {selectedIndex} EOD data...</div>
//       )} */}

//       {dashboardTrendError && (
//         <div className="sm__empty">
//           <div className="sm__empty-title">{dashboardTrendError}</div>
//         </div>
//       )}

//       {/* ── Table ── */}
//       {sorted.length > 0 && (
//         <div className="sm__table-wrap">
//           <table className="sm__table option-table">
//             <thead>
//               <tr>
//                 <SortTh label="Company" field="symbol" align="left" />
//                 <SortTh label="LTP" field="ltp" tooltip={TOOLTIPS?.ltp} />
//                 <SortTh
//                   label="RSI & MACD"
//                   field="prediction"
//                   tooltip={TOOLTIPS?.rsiMacdSignal}
//                 />
//                 <SortTh label="Open" field="open" />
//                 <SortTh label="High" field="high" />
//                 <SortTh label="Low" field="low" />
//                 <SortTh label="Prev Close" field="prevClose" />
//                 <SortTh
//                   label="% Change"
//                   field="percentChange"
//                   tooltip={TOOLTIPS?.percentChange}
//                 />
//                 <SortTh label="R1" field="r1" />
//                 <SortTh label="S1" field="s1" />
//                 <SortTh
//                   label="Closing Strength"
//                   field="closingStrength"
//                   tooltip={CLOSE_STRENGTH_TIP}
//                 />
//                 <SortTh
//                   label="Rebound Strength"
//                   field="reboundStrength"
//                   tooltip={REBOUND_TIP}
//                 />
//                 <SortTh
//                   label="Distance to High"
//                   field="distanceToHigh"
//                   tooltip={DISTANCE_TIP}
//                 />
//               </tr>
//             </thead>

//             <tbody>
//               {sorted.map((stock) => {
//                 const m = getMetrics(stock);
//                 const r1 = stock?.resDaily?.classic?.R1;
//                 const s1 = stock?.resDaily?.classic?.S1;

//                 return (
//                   <tr
//                     key={stock.symbol}
//                     className="sm__row"
//                     onClick={() =>
//                       navigate(
//                         `/stockdetail/${stock.symbol}/${stock.security_id}`
//                       )
//                     }
//                   >

//                     <td className="sm__td-name">
//                       <div>
//                         <span className="sm__symbol">{stock.symbol}</span>
//                         {stock.company && (
//                           <small
//                             style={{
//                               display: "block",
//                               color: "#6b7280",
//                               fontSize: "11px",
//                             }}
//                           >
//                             {stock.company}
//                           </small>
//                         )}
//                       </div>
//                     </td>

//                     <td className="sm__td-num">
//                       {m?.ltp
//                         ? `₹${m.ltp.toLocaleString("en-IN", {
//                             minimumFractionDigits: 2,
//                             maximumFractionDigits: 2,
//                           })}`
//                         : "—"}
//                     </td>

//                     <td className="sm__td-num">
//                       <span
//                         className={`sm__signal-badge ${getBadgeClass(stock?.prediction)}`}
//                       >
//                         {stock?.prediction || "—"}
//                       </span>
//                     </td>

//                     <td className="sm__td-num">
//                       {m?.open ? `₹${m.open}` : "—"}
//                     </td>

//                     <td className="sm__td-num">
//                       {m?.high ? `₹${m.high}` : "—"}
//                     </td>

//                     <td className="sm__td-num">
//                       {m?.low ? `₹${m.low}` : "—"}
//                     </td>

//                     <td className="sm__td-num">
//                       {m?.prevClose ? `₹${m.prevClose}` : "—"}
//                     </td>

//                     <td
//                       className="sm__td-num"
//                       style={{
//                         color:
//                           m?.percentChange > 0
//                             ? "#249966"
//                             : m?.percentChange < 0
//                               ? "#f87171"
//                               : "#64748b",
//                         fontWeight: 600,
//                       }}
//                     >
//                       {m?.percentChange != null
//                         ? `${m.percentChange > 0 ? "+" : ""}${m.percentChange}%`
//                         : "—"}
//                     </td>

//                     <td className="sm__td-num" style={{ color: "#249966" }}>
//                       {r1 ? `₹${Number(r1).toFixed(2)}` : "—"}
//                     </td>

//                     <td className="sm__td-num" style={{ color: "#f87171" }}>
//                       {s1 ? `₹${Number(s1).toFixed(2)}` : "—"}
//                     </td>

//                     <td
//                       className="sm__td-num"
//                       style={{
//                         color: getClosingColor(m?.closingStrength),
//                         fontWeight: 700,
//                       }}
//                     >
//                       {m?.closingStrength != null
//                         ? `${m.closingStrength}%`
//                         : "—"}
//                     </td>

//                     <td
//                       className="sm__td-num"
//                       style={{
//                         color: getReboundColor(m?.reboundStrength),
//                         fontWeight: 700,
//                       }}
//                     >
//                       {m?.reboundStrength != null
//                         ? `${m.reboundStrength}%`
//                         : "—"}
//                     </td>

//                     <td
//                       className="sm__td-num"
//                       style={{
//                         color: getDistanceColor(m?.distanceToHigh),
//                         fontWeight: 700,
//                       }}
//                     >
//                       {m?.distanceToHigh != null
//                         ? `${m.distanceToHigh}%`
//                         : "—"}
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* {!dashboardTrendLoading && !sorted.length && !dashboardTrendError && (
//         <div className="sm__empty">
//           <div className="sm__empty-icon">📊</div>
//           <div className="sm__empty-title">No data available</div>
//           <div className="sm__empty-sub">
//             Try selecting a different index or refresh
//           </div>
//         </div>
//       )} */}
//     </div>
//   );
// };
// const INDICES = [
//   "NIFTY 50",
//   "NIFTY BANK",
//   "NIFTY IT",
//   "NIFTY NEXT 50",
//   "NIFTY MIDCAP 100",
// ];

const TIMEFRAMES = [
  { key: "daily", label: "Daily" },
  { key: "weekly", label: "Weekly" },
  { key: "monthly", label: "Monthly" },
];

const getBadgeClass = (signal) => {
  const s = signal?.toUpperCase?.();
  if (s === "BUY" || s === "BULLISH") return "sm__signal--strong";
  if (s === "SELL" || s === "BEARISH") return "sm__signal--weak";
  return "sm__signal--moderate";
};

const getCrossoverClass = (crossover) => {
  if (crossover === "bullish") return "sm__clr-bull";
  if (crossover === "bearish") return "sm__clr-bear";
  return "sm__clr-neutral";
};

// const getMetrics = (stock, timeframe) => {
//   const p = stock?.predictions?.[timeframe];
//   if (!p) return null;

//   return {
//     rsi: p.rsi != null ? Number(p.rsi.toFixed(2)) : null,
//     macd: p.macd != null ? Number(p.macd.toFixed(2)) : null,
//     macd_signal:
//       p.macd_signal != null ? Number(p.macd_signal.toFixed(2)) : null,
//     histogram: p.histogram != null ? Number(p.histogram.toFixed(2)) : null,
//     prediction: p.prediction || "Neutral",
//     prediction_result: p.prediction_result || "—",
//     macd_crossover: p.macd_crossover || "none",
//     crossover_high: p.crossover_high ?? null,
//     crossover_low: p.crossover_low ?? null,
//     crossover_close: p.crossover_close ?? null,
//     crossover_date: p.crossover_date ?? null,

//     //new data
//     sl_price: p.sl_price ?? null,
//     target_price: p.target_price ?? null,
//     sl_hit_date: p.sl_hit_date ?? null,
//     high_hit_date: p.high_hit_date ?? null,
//     target_hit_date: p.target_hit_date ?? null,
//     trade_status: p.trade_status ?? "OPEN",
//     days_to_target: p.days_to_target ?? null,
//   };
// };

const getMetrics = (stock, timeframe) => {
  const p = stock?.predictions?.[timeframe];
  if (!p) return null;

  return {
    // ── existing fields ──
    rsi: p.rsi != null ? Number(p.rsi.toFixed(2)) : null,
    macd: p.macd != null ? Number(p.macd.toFixed(2)) : null,
    macd_signal:
      p.macd_signal != null ? Number(p.macd_signal.toFixed(2)) : null,
    histogram: p.histogram != null ? Number(p.histogram.toFixed(2)) : null,
    prediction: p.prediction || "Neutral",
    prediction_result: p.prediction_result || "—",
    macd_crossover: p.macd_crossover || "none",
    crossover_high: p.crossover_high ?? null,
    crossover_low: p.crossover_low ?? null,
    crossover_close: p.crossover_close ?? null,
    crossover_date: p.crossover_date ?? null,

    // ── outcome fields ──
    sl_price: p.sl_price ?? null,
    target_price: p.target_price ?? null,
    sl_hit_date: p.sl_hit_date ?? null,
    high_hit_date: p.high_hit_date ?? null,
    target_hit_date: p.target_hit_date ?? null,
    trade_status: p.trade_status ?? "OPEN",
    days_to_target: p.days_to_target ?? null,

    // ── new: entry / exit tracking ──
    entry_date: p.entry_date ?? null,
    exit_date: p.exit_date ?? null,
    exit_reason: p.exit_reason ?? null,
    exit_price: p.exit_price ?? null,
    holding_days: p.holding_days ?? null,
  };
};
const getStatusDisplay = (status) => {
  switch (status) {
    case "TARGET_HIT":
      return { label: "🎯 Target", cls: "sm__status--target" };
    case "SL_HIT":
      return { label: "⚠️ SL Hit", cls: "sm__status--sl" };
    case "SL_THEN_TARGET":
      return { label: "🟡 SL → Target", cls: "sm__status--sl-then-target" };
    case "OPEN":
      return { label: "⏳ Open", cls: "sm__status--open" };
    case "PENDING": // ADD
      return { label: "⏸ Not Entered", cls: "sm__status--pending" }; // ADD
    default:
      return { label: status || "—", cls: "sm__status--open" };
  }
};
const CrossoverMomentum = () => {
  const navigate = useNavigate();
  const {
    dashboardTrendData,
    dashboardTrendLoading,
    dashboardTrendError,
    loadDashboardIndexTrend,
    resetDashboardTrendData,
    allCrossoverData,
    allCrossoverLoading,
    allCrossoverError,
    loadAllCrossover,
  } = useMarketSnapshot();
  console.log("Dashboard Tren data", dashboardTrendData);
  const { exportCSV, exportExcel, exporting } = useExport();
  const { prices: livePrices, subscribeSymbols } = useLivePrices();
  const { indexSymbols } = useIndexSymbols();

  const [selectedIndex, setSelectedIndex] = useState(
    () => localStorage.getItem("crossoverSelectedIndex") || "ALL",
  );
  const [timeframe, setTimeframe] = useState("daily");
  //   const [sortKey, setSortKey] = useState("rsi");
  //   const [sortDir, setSortDir] = useState("desc");
  const [sortKey, setSortKey] = useState("symbol");
  const [sortDir, setSortDir] = useState("asc");
  const [filter, setFilter] = useState("All");

  const [timeframes, setTimeframes] = useState(["daily"]);
  // ── Fetch data ──
  const toggleTimeframe = (key) => {
    setTimeframes((prev) =>
      prev.includes(key)
        ? prev.length > 1
          ? prev.filter((t) => t !== key)
          : prev
        : [...prev, key],
    );
  };

  //previous working useEffect
  // useEffect(() => {
  //   if (!selectedIndex) return;
  //   localStorage.setItem("selectedIndex", selectedIndex);
  //   const symbols = indexSymbols?.[selectedIndex] || [];
  //   if (symbols.length) subscribeSymbols(symbols);
  //   loadDashboardIndexTrend({ indexName: selectedIndex });

  //   const interval = setInterval(
  //     () => {
  //       if (!document.hidden)
  //         loadDashboardIndexTrend({ indexName: selectedIndex });
  //     },
  //     5 * 60 * 1000,
  //   );

  //   return () => clearInterval(interval);
  // }, [selectedIndex]);
  // One-time universe load (cached till EOD both in browser + backend)
  useEffect(() => {
    loadAllCrossover();
  }, []);
  console.log("Crossover all data", allCrossoverData);

  // WebSocket subscription follows the selected index
  useEffect(() => {
    if (!selectedIndex) return;
    localStorage.setItem("crossoverSelectedIndex", selectedIndex);

    const symbols =
      selectedIndex === "ALL"
        ? (allCrossoverData?.data || []).map((r) => r.symbol)
        : indexSymbols?.[selectedIndex] || [];

    if (symbols.length) subscribeSymbols(symbols);
  }, [selectedIndex, indexSymbols, allCrossoverData]);
  // ── Derived data ──
  // const trendRows = useMemo(
  //   () => Object.values(dashboardTrendData || {}),
  //   [dashboardTrendData],
  // );
  const trendRows = useMemo(() => {
    const all = allCrossoverData?.data || [];
    if (!selectedIndex || selectedIndex === "ALL") return all;
    return all.filter((row) => row.indexes?.includes(selectedIndex));
  }, [allCrossoverData, selectedIndex]);

  const lastDate = useMemo(() => {
    const d = trendRows?.[0]?.dates?.at(-1);
    if (!d) return "";
    return new Date(d).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }, [trendRows]);

  // ── Sort + filter ──
  const sorted = useMemo(() => {
    // const filtered =
    //   filter === "All"
    //     ? trendRows
    //     : trendRows.filter((s) => {
    //         const pred =
    //           s?.predictions?.[timeframe]?.prediction?.toUpperCase?.();
    //         if (filter === "Bullish") return pred === "BULLISH";
    //         if (filter === "Bearish") return pred === "BEARISH";
    //         return pred === "NEUTRAL" || !pred;
    //       });

    // return [...filtered].sort((a, b) => {
    //   const mA = getMetrics(a, timeframe);
    //   const mB = getMetrics(b, timeframe);
    const filtered =
      filter === "All"
        ? trendRows
        : trendRows.filter((s) => {
            return timeframes.every((tf) => {
              const pred = s?.predictions?.[tf]?.prediction?.toUpperCase?.();
              if (filter === "Bullish") return pred === "BULLISH";
              if (filter === "Bearish") return pred === "BEARISH";
              return pred === "NEUTRAL" || !pred;
            });
          });

    return [...filtered].sort((a, b) => {
      const mA = getMetrics(a, timeframes[0]);
      const mB = getMetrics(b, timeframes[0]);

      if (!mA && !mB) return 0;
      if (!mA) return 1;
      if (!mB) return -1;

      let aVal, bVal;

      if (sortKey === "symbol") {
        aVal = a?.symbol || "";
        bVal = b?.symbol || "";
        return sortDir === "asc"
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      }
      // if (sortKey === "crossover_date") {

      //   const aT = mA?.crossover_date
      //     ? new Date(mA.crossover_date).getTime()
      //     : null;
      //   const bT = mB?.crossover_date
      //     ? new Date(mB.crossover_date).getTime()
      //     : null;

      //   if (aT == null && bT == null) return 0;
      //   if (aT == null) return 1;
      //   if (bT == null) return -1;

      //   // asc = oldest first, desc = latest first
      //   return sortDir === "asc" ? aT - bT : bT - aT;
      // }
      if (
        sortKey === "crossover_date" ||
        sortKey === "entry_date" ||
        sortKey === "exit_date" ||
        sortKey === "sl_hit_date" ||
        sortKey === "target_hit_date" ||
        sortKey === "high_hit_date"
      ) {
        const aT = mA?.[sortKey] ? new Date(mA[sortKey]).getTime() : null;
        const bT = mB?.[sortKey] ? new Date(mB[sortKey]).getTime() : null;
        if (aT == null && bT == null) return 0;
        if (aT == null) return 1;
        if (bT == null) return -1;
        return sortDir === "asc" ? aT - bT : bT - aT;
      }

      if (sortKey === "prediction") {
        const rank = { Bullish: 1, Neutral: 2, Bearish: 3 };
        aVal = rank[mA?.prediction] || 99;
        bVal = rank[mB?.prediction] || 99;
      } else if (sortKey === "macd_crossover") {
        const rank = { bullish: 1, none: 2, bearish: 3 };
        aVal = rank[mA?.macd_crossover] || 99;
        bVal = rank[mB?.macd_crossover] || 99;
      } else {
        aVal = mA?.[sortKey] ?? -Infinity;
        bVal = mB?.[sortKey] ?? -Infinity;
      }

      return sortDir === "asc" ? aVal - bVal : bVal - aVal;
    });
  }, [trendRows, filter, sortKey, sortDir, timeframe]);

  // ── Sort handler ──
  const handleSort = useCallback(
    (key) => {
      if (sortKey === key) setSortDir(sortDir === "desc" ? "asc" : "desc");
      else {
        setSortKey(key);
        setSortDir("desc");
      }
    },
    [sortKey, sortDir],
  );

  // const handleIndexChange = useCallback((e) => {
  //   const value = e.target.value;
  //   if (!value) return;
  //   resetDashboardTrendData();
  //   setSelectedIndex(value);
  // }, []);
  const handleIndexChange = useCallback((e) => {
    const value = e.target.value;
    if (!value) return;
    setSelectedIndex(value);
  }, []);

  // const handleRefresh = useCallback(() => {
  //   loadDashboardIndexTrend({ indexName: selectedIndex });
  // }, [selectedIndex]);
  const handleRefresh = useCallback(() => {
    loadAllCrossover(true); // force bypass cache
  }, [loadAllCrossover]);

  // ── SortTh ──
  //   const SortTh = ({ label, field, align, tooltip }) => (
  //     <th
  //       onClick={() => handleSort(field)}
  //       className={align === "left" ? "sm__th-left" : ""}
  //     >
  //       {label}
  //       {tooltip && <InfoTooltip text={tooltip} />}
  //       {sortKey === field && (
  //         <span className="sm__sort-arrow">
  //           {sortDir === "asc" ? " ↑" : " ↓"}
  //         </span>
  //       )}
  //     </th>
  //   );
  const SortTh = ({ label, field, align, tooltip, show = true }) => (
    <th className={align === "left" ? "sm__th-left" : ""}>
      <div className="sm__sort-head">
        {label}
        {tooltip && <InfoTooltip text={TOOLTIPS[tooltip]} />}
        {show && (
          <span className="sm__sort-arrows">
            <FaChevronUp
              size={10}
              className={sortKey === field && sortDir === "asc" ? "active" : ""}
              onClick={(e) => {
                e.stopPropagation();
                setSortKey(field);
                setSortDir("asc");
              }}
            />
            <FaChevronDown
              size={10}
              className={
                sortKey === field && sortDir === "desc" ? "active" : ""
              }
              onClick={(e) => {
                e.stopPropagation();
                setSortKey(field);
                setSortDir("desc");
              }}
            />
          </span>
        )}
      </div>
    </th>
  );

  //new code
  const EXPORT_COLUMNS = [
    { header: "Symbol", key: "symbol", width: 15 },
    { header: "Company", key: "company", width: 20 },
    { header: "LTP", key: "ltp", width: 12 },
    { header: "Timeframe", key: "timeframe", width: 10 },
    { header: "RSI", key: "rsi", width: 10 },
    { header: "MACD", key: "macd", width: 12 },
    { header: "Signal Line", key: "macd_signal", width: 12 },
    { header: "Histogram", key: "histogram", width: 12 },
    { header: "Crossover", key: "macd_crossover", width: 12 },
    { header: "Crossover Date", key: "crossover_date", width: 15 },
    { header: "Crossover Close", key: "crossover_close", width: 14 },
    { header: "Crossover High", key: "crossover_high", width: 14 },
    { header: "Crossover Low", key: "crossover_low", width: 14 },
    { header: "Momentum", key: "prediction", width: 12 },
    { header: "Result", key: "prediction_result", width: 14 },
  ];

  const buildExportRows = () => {
    const out = [];
    sorted.forEach((stock) => {
      const live = livePrices[stock?.symbol];
      const dbLtp =
        stock?.quote?.data?.last_price ?? stock?.quote?.data?.ltp ?? null;
      const ltp = live?.ltp ?? dbLtp;

      timeframes
        .filter((tf) => getMetrics(stock, tf))
        .forEach((tf) => {
          const m = getMetrics(stock, tf);
          out.push({
            symbol: stock.symbol,
            company: stock.company || "",
            ltp: ltp ?? "",
            timeframe: tf,
            rsi: m?.rsi ?? "",
            macd: m?.macd ?? "",
            macd_signal: m?.macd_signal ?? "",
            histogram: m?.histogram ?? "",
            macd_crossover: m?.macd_crossover ?? "",
            crossover_date: m?.crossover_date ?? "",
            crossover_close: m?.crossover_close ?? "",
            crossover_high: m?.crossover_high ?? "",
            crossover_low: m?.crossover_low ?? "",
            target: computeTarget(m, filter) ?? "",
            prediction: m?.prediction ?? "",
            prediction_result: m?.prediction_result ?? "",
          });
        });
    });
    return out;
  };

  const hideCrossoverLow = filter === "Bullish";
  const hideCrossoverHigh = filter === "Bearish";
  const showTarget = filter === "Bullish" || filter === "Bearish";
  const filterSuffix = showTarget ? `_${filter.toLowerCase()}` : "";
  const exportColumns = showTarget
    ? [...EXPORT_COLUMNS, { header: "Target", key: "target", width: 12 }]
    : EXPORT_COLUMNS;
  const handleDownloadCSV = () =>
    exportCSV({
      rows: buildExportRows(),
      columns: exportColumns,
      filename: `${selectedIndex}_${filterSuffix}_crossover_momentum`,
      sheetName: selectedIndex,
    });

  const handleDownloadExcel = () =>
    exportExcel({
      rows: buildExportRows(),
      columns: exportColumns,
      filename: `${selectedIndex}_${filterSuffix}_crossover_momentum`,
      sheetName: selectedIndex,
    });
  const TARGET_PCT = 0.05; // 5%

  const computeTarget = (m, filter) => {
    const high = Number(m?.crossover_high);
    const low = Number(m?.crossover_low);

    // Decide direction: explicit filter wins, else fall back to the row's own crossover
    let direction = null;
    if (filter === "Bullish") direction = "bullish";
    else if (filter === "Bearish") direction = "bearish";
    else direction = m?.macd_crossover; // "bullish" | "bearish" | "none"

    if (direction === "bullish" && Number.isFinite(high)) {
      return Number((high * (1 + TARGET_PCT)).toFixed(2)); // high + 5%
    }
    if (direction === "bearish" && Number.isFinite(low)) {
      return Number((low * (1 - TARGET_PCT)).toFixed(2)); // low − 5%
    }
    return null;
  };

  return (
    <div className="sm">
      {/* ── Header ── */}
      <div className="sm__header">
        <div className="sm__header-left">
          <div className="sm__title-row">
            <button className="sm__back" onClick={() => navigate(-1)}>
              ←
            </button>
            <h1 className="sm__title">Crossover Momentum</h1>
          </div>
          <p className="sm__sub">
            RSI, MACD &amp; crossover signals across Daily, Weekly &amp; Monthly
            timeframes
          </p>
        </div>

        <div className="sm__header-right">
          {/* <select
            className="sm__index-select"
            value={selectedIndex}
            onChange={handleIndexChange}
          >
            {nseIndicesOptions?.map((idx) => (
              <option key={idx} value={idx}>
                {idx}
              </option>
            ))}
          </select> */}
          <select
            className="sm__index-select"
            value={selectedIndex}
            onChange={handleIndexChange}
          >
            <option value="ALL">All ({allCrossoverData?.count || 0})</option>
            {nseIndicesOptions?.map((idx) => (
              <option key={idx} value={idx}>
                {idx}
              </option>
            ))}
          </select>

          <button className="sm__refresh-btn" onClick={handleRefresh}>
            <FiRefreshCw size={14} />
          </button>
        </div>

        <button
          className="sm__refresh-btn"
          onClick={handleDownloadCSV}
          disabled={exporting}
        >
          {exporting ? "…" : "CSV ⬇"}
        </button>
        <button
          className="sm__refresh-btn"
          onClick={handleDownloadExcel}
          disabled={exporting}
        >
          {exporting ? "…" : "Excel ⬇"}
        </button>
      </div>

      {/* ── Meta bar with timeframe toggle ── */}
      <div className="sm__result-bar">
        {/* <span>
          {lastDate && `As on ${lastDate}`} — <b>{sorted.length}</b> stocks
        </span> */}

        {/* Timeframe toggle */}
        <div
          className="sm__timeframe-group"
          style={{ display: "flex", gap: "4px" }}
        >
          {/* {TIMEFRAMES.map((tf) => (
            <button
              key={tf.key}
              className={`sm__filter-btn ${timeframe === tf.key ? "active" : ""}`}
              onClick={() => setTimeframe(tf.key)}
            >
              {tf.label}
            </button>
          ))} */}
          {TIMEFRAMES.map((tf) => (
            <button
              key={tf.key}
              className={`sm__filter-btn ${timeframes.includes(tf.key) ? "active" : ""}`}
              onClick={() => toggleTimeframe(tf.key)}
            >
              {tf.label}
            </button>
          ))}
        </div>

        {/* Signal filter */}
        <div
          className="sm__signal-filter-group"
          style={{ display: "flex", gap: "4px" }}
        >
          {["All", "Bullish", "Neutral", "Bearish"].map((f) => (
            <button
              key={f}
              className={`sm__filter-btn ${filter === f ? "active" : ""}`}
              onClick={() => setFilter(f)}
            >
              {f}
            </button>
          ))}
        </div>
      </div>

      {/* ── Loading / Error ── */}
      {/* {dashboardTrendLoading && !sorted.length && (
        <div className="sm__loading">Fetching {selectedIndex} data...</div>
      )}

      {dashboardTrendError && (
        <div className="sm__empty">
          <div className="sm__empty-title">{dashboardTrendError}</div>
        </div>
      )} */}
      {allCrossoverLoading && !sorted.length && (
        <div className="sm__loading">Loading crossover universe...</div>
      )}

      {allCrossoverError && (
        <div className="sm__empty">
          <div className="sm__empty-title">{allCrossoverError}</div>
        </div>
      )}

      {/* ── Table ── */}
      {sorted.length > 0 && (
        <div className="sm__table-wrap">
          <table className="sm__table ">
            <thead>
              <tr>
                <SortTh label="Symbol" field="symbol" align="left" />
                <th>LTP</th>
                <SortTh
                  label="TF"
                  field="timeframe"
                  tooltip="tf"
                  show={false}
                />
                {/* <th>
                  TF <InfoTooltip text={TOOLTIPS.tf} />
                </th> */}
                {/* <th>TF</th> */}

                <SortTh
                  label="Crossover"
                  field="macd_crossover"
                  tooltip="macdCrossover"
                />

                <SortTh label="Crossover Date" field="crossover_date" />
                <th>Crossover Close</th>
                {!hideCrossoverHigh && <th>Crossover High</th>}
                {!hideCrossoverLow && <th>Crossover Low</th>}
                {showTarget && <th>Target</th>}

                {/* new column */}
                <SortTh label="SL" field="sl_price" />
                <SortTh label="Target" field="target_price" />
                <SortTh label="SL Hit Date" field="sl_hit_date" />
                <SortTh label="High Hit Date" field="high_hit_date" />
                <SortTh label="Entry Date" field="entry_date" />
                <SortTh label="Exit Date" field="exit_date" />
                <SortTh label="Target Hit Date" field="target_hit_date" />
                <th>Status</th>

                {/* <SortTh label="Signal Line" field="macd_signal" />
                <SortTh label="Histogram" field="histogram" />
                <SortTh label="Crossover" field="macd_crossover" />
                <SortTh label="Momentum" field="momentum" /> */}
                <SortTh
                  label="Momentum"
                  field="macd_pred_signal"
                  tooltip="momentum"
                />
                <SortTh
                  label="Result"
                  field="result"
                  tooltip="momentumResult"
                />
                <SortTh label="RSI" field="rsi" />
                <SortTh label="MACD" field="macd" />
                <SortTh
                  label="Signal Line"
                  field="macd_signal"
                  tooltip="macdSignalLine"
                />
                <SortTh
                  label="Histogram"
                  field="histogram"
                  tooltip="macdHistogram"
                />
                {/* <th>Result</th> */}
              </tr>
            </thead>

            {/* <tbody>
              {sorted.map((stock) => {
                const m = getMetrics(stock, timeframe);

                return (
                  <tr
                    key={stock.symbol}
                    className="sm__row"
                    onClick={() =>
                      navigate(
                        `/stockdetail/${stock.symbol}/${stock.security_id}`,
                      )
                    }
                  >
                 
                    <td className="sm__td-name">
                      <div>
                        <span className="sm__symbol">{stock.symbol}</span>
                        {stock.company && (
                          <small
                            style={{
                              display: "block",
                              color: "#6b7280",
                              fontSize: "11px",
                            }}
                          >
                            {stock.company}
                          </small>
                        )}
                      </div>
                    </td>

                   
                    <td
                      className="sm__td-num"
                      style={{
                        color:
                          m?.rsi > 55
                            ? "#249966"
                            : m?.rsi < 45
                              ? "#f87171"
                              : "#64748b",
                        fontWeight: 600,
                      }}
                    >
                      {m?.rsi ?? "—"}
                    </td>

                  
                    <td
                      className="sm__td-num"
                      style={{
                        color:
                          m?.macd > 0
                            ? "#249966"
                            : m?.macd < 0
                              ? "#f87171"
                              : "#64748b",
                        fontWeight: 600,
                      }}
                    >
                      {m?.macd ?? "—"}
                    </td>

                    
                    <td className="sm__td-num" style={{ color: "#64748b" }}>
                      {m?.macd_signal ?? "—"}
                    </td>

                  
                    <td
                      className="sm__td-num"
                      style={{
                        color:
                          m?.histogram > 0
                            ? "#249966"
                            : m?.histogram < 0
                              ? "#f87171"
                              : "#64748b",
                        fontWeight: 600,
                      }}
                    >
                      {m?.histogram ?? "—"}
                    </td>

                   
                    <td className="sm__td-num">
                      <span
                        className={`sm__signal-pill ${getCrossoverClass(m?.macd_crossover)}`}
                      >
                        {m?.macd_crossover === "bullish"
                          ? "↑ Bullish"
                          : m?.macd_crossover === "bearish"
                            ? "↓ Bearish"
                            : "—"}
                      </span>
                    </td>

                   
                    <td className="sm__td-num">
                      <span
                        className={`sm__signal-badge ${getBadgeClass(m?.prediction)}`}
                      >
                        {m?.prediction || "—"}
                      </span>
                    </td>

                   
                    <td
                      className="sm__td-num"
                      style={{ fontSize: "12px", color: "#6b7280" }}
                    >
                      {m?.prediction_result || "—"}
                    </td>
                  </tr>
                );
              })}
            </tbody> */}
            <tbody>
              {sorted.map((stock) => {
                const activeTFs = timeframes.filter((tf) =>
                  getMetrics(stock, tf),
                );
                const live = livePrices[stock?.symbol];
                // const ltp = live?.ltp;
                const dbLtp =
                  stock?.quote?.data?.last_price ??
                  stock?.quote?.data?.ltp ??
                  null;
                const ltp = live?.ltp ?? dbLtp;
                if (!activeTFs.length) return null;

                return activeTFs.map((tf, i) => {
                  const m = getMetrics(stock, tf);
                  const isFirst = i === 0;
                  const statusInfo = getStatusDisplay(m.trade_status);
                  const isYellow = m.trade_status === "SL_THEN_TARGET";

                  return (
                    <tr
                      key={`${stock.symbol}-${tf}`}
                      className={`sm__row ${isYellow ? "sm__row--yellow" : ""}`}
                      onClick={() =>
                        navigate(
                          `/stockdetail/${stock.symbol}/${stock.security_id}`,
                        )
                      }
                    >
                      <td className="sm__td-name">
                        {isFirst ? (
                          <div>
                            <span className="sm__symbol">{stock.symbol}</span>
                            {stock.company && (
                              <small
                                style={{
                                  display: "block",
                                  color: "#6b7280",
                                  fontSize: "11px",
                                }}
                              >
                                {stock.company}
                              </small>
                            )}
                          </div>
                        ) : null}
                      </td>
                      {/* <td>{ltp?{₹ltp}:"-"}</td> */}
                      <td>{ltp ? `₹${ltp}` : "-"}</td>

                      <td
                        className="sm__td-num"
                        style={{ fontSize: "11px", fontWeight: 600 }}
                      >
                        {tf[0].toUpperCase()}
                      </td>

                      <td className="sm__td-num">
                        <span
                          className={`sm__signal-pill ${getCrossoverClass(m?.macd_crossover)}`}
                        >
                          {m?.macd_crossover === "bullish"
                            ? "↑ Bullish"
                            : m?.macd_crossover === "bearish"
                              ? "↓ Bearish"
                              : "—"}
                        </span>
                      </td>
                      <td className="sm__td-num">{m.crossover_date}</td>

                      <td className="sm__td-num">{m.crossover_close}</td>
                      {!hideCrossoverHigh && (
                        <td className="sm__td-num">{m.crossover_high}</td>
                      )}
                      {!hideCrossoverLow && (
                        <td className="sm__td-num">{m.crossover_low}</td>
                      )}
                      {showTarget && (
                        <td
                          className="sm__td-num"
                          style={{
                            fontWeight: 600,
                            color: filter === "Bearish" ? "#f87171" : "#249966",
                          }}
                        >
                          {(() => {
                            const target = computeTarget(m, filter);
                            return target != null ? `₹${target}` : "—";
                          })()}
                        </td>
                      )}
                      {/* new column  */}
                      <td
                        className="sm__td-num"
                        style={{ color: "#f87171", fontWeight: 600 }}
                      >
                        {m.sl_price ? `₹${m.sl_price}` : "—"}
                      </td>
                      <td
                        className="sm__td-num"
                        style={{ color: "#249966", fontWeight: 600 }}
                      >
                        {m.target_price ? `₹${m.target_price}` : "—"}
                      </td>
                      <td className="sm__td-num">{m.sl_hit_date ?? "—"}</td>
                      <td className="sm__td-num">{m.high_hit_date ?? "—"}</td>
                      <td className="sm__td-num">{m.entry_date ?? "—"}</td>
                      <td className="sm__td-num">
                        {m.exit_date ? (
                          <>
                            {m.exit_date}
                            {m.exit_reason && (
                              <small
                                style={{
                                  display: "block",
                                  color:
                                    m.exit_reason === "SL"
                                      ? "#f87171"
                                      : "#249966",
                                  fontSize: 11,
                                  fontWeight: 600,
                                }}
                              >
                                {m.exit_reason === "SL" ? "SL" : "🎯 Target"}
                                {m.holding_days != null &&
                                  ` · ${m.holding_days}d`}
                              </small>
                            )}
                          </>
                        ) : (
                          "—"
                        )}
                      </td>
                      <td className="sm__td-num">{m.target_hit_date ?? "—"}</td>
                      <td className="sm__td-num">
                        <span className={`sm__status ${statusInfo.cls}`}>
                          {statusInfo.label}
                        </span>
                        {m.trade_status === "OPEN" && m.crossover_date && (
                          <small
                            style={{
                              color: "#9ca3af",
                              marginLeft: 4,
                              fontSize: 11,
                            }}
                          >
                            (
                            {Math.round(
                              (Date.now() -
                                new Date(m.crossover_date).getTime()) /
                                86400000,
                            )}
                            d)
                          </small>
                        )}
                      </td>

                      <td className="sm__td-num">
                        <span
                          className={`sm__signal-badge ${getBadgeClass(m?.prediction)}`}
                        >
                          {m?.prediction || "—"}
                        </span>
                      </td>

                      <td
                        className="sm__td-num"
                        style={{ fontSize: "12px", color: "#6b7280" }}
                      >
                        {m?.prediction_result || "—"}
                      </td>

                      <td
                        className="sm__td-num"
                        style={{
                          color:
                            m?.rsi > 55
                              ? "#249966"
                              : m?.rsi < 45
                                ? "#f87171"
                                : "#64748b",
                          fontWeight: 600,
                        }}
                      >
                        {m?.rsi ?? "—"}
                      </td>

                      <td
                        className="sm__td-num"
                        style={{
                          color:
                            m?.macd > 0
                              ? "#249966"
                              : m?.macd < 0
                                ? "#f87171"
                                : "#64748b",
                          fontWeight: 600,
                        }}
                      >
                        {m?.macd ?? "—"}
                      </td>

                      <td className="sm__td-num" style={{ color: "#64748b" }}>
                        {m?.macd_signal ?? "—"}
                      </td>

                      <td
                        className="sm__td-num"
                        style={{
                          color:
                            m?.histogram > 0
                              ? "#249966"
                              : m?.histogram < 0
                                ? "#f87171"
                                : "#64748b",
                          fontWeight: 600,
                        }}
                      >
                        {m?.histogram ?? "—"}
                      </td>
                    </tr>
                  );
                });
              })}
            </tbody>
          </table>
        </div>
      )}

      {!dashboardTrendLoading && !sorted.length && !dashboardTrendError && (
        <div className="sm__empty">
          <div className="sm__empty-icon">📊</div>
          <div className="sm__empty-title">No data available</div>
          <div className="sm__empty-sub">
            Try selecting a different index or refresh
          </div>
        </div>
      )}
    </div>
  );
};

export default CrossoverMomentum;
